var map = {
	"./poly-1.png": "aab0",
	"./poly-10.png": "d699",
	"./poly-11.png": "6702",
	"./poly-12.png": "6e75",
	"./poly-2.png": "cf50",
	"./poly-3.png": "ec34",
	"./poly-4.png": "d9e9",
	"./poly-5.png": "a94d",
	"./poly-6.png": "70d2",
	"./poly-7.png": "298b",
	"./poly-8.png": "f884",
	"./poly-9.png": "5f61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67c3";